<template>
  <v-data-table
      v-model="selected"
      color="blue lighten-4"
      item-key="movimento.id"
      :headers="headers"
      :items="fornitoriSorted"
      :options.sync="options"
      :loading="loading"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
    >
    <template v-slot:top>
      <v-toolbar flat>
<!--         <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="onNuovoFornitore">Aggiungi Fornitore</v-btn> -->
        <v-dialog v-model="dialog" max-width="1000px">
          <template v-slot:activator="{ on, attrs }">
            <v-spacer></v-spacer>
            <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" dense>Aggiungi Fornitore</v-btn>            
            <v-spacer></v-spacer>
          </template>
          <v-card :loading="loading">
            <v-card-title>
              <span class="text-h5">Aggiungi fornitore</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4" >
                    <v-select :items="elencoFornitori" label="Fornitore" v-model="editedItem" item-value="codice" item-text="ragioneSociale" hide-details return-object></v-select> 
                  </v-col>
                  <v-col cols="12" sm="6" md="4" >
                    <v-switch v-model="editedItem.default" dense inset label="Principale" @change="onChangeDefault"></v-switch>
                  </v-col>  
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>         
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Annulla</v-btn>
              <v-btn color="blue darken-1" text @click="save">Salva</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="600px">
          <v-card>
            <v-card-title class="text-h5">Sei sicuro di voler cancellare questo fornitore?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>    
    <template v-slot:[`item.ultimoMovimento.data`]="{ item }">
      {{ item.ultimoMovimento && item.ultimoMovimento.data && item.ultimoMovimento.data.substring(0, 22) | dateTime }}
    </template>
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data | dateNull }}
    </template>
    <template v-slot:[`item.default`]="{ item }">
      {{ item.default ? 'SI' : 'NO' }}
    </template>    
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
      <v-icon small class="ml-4" @click="deleteItem(item)">mdi-delete</v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="refreshFornitori">Ricarica</v-btn>
    </template> 
    </v-data-table>
</template>

<script>
  import _ from 'lodash'
  import clienti from '@/services/clientiService.js'

  /* eslint-disable */
  export default {
    props: {
      item: Object,
      refresh: Number
    },
    data: () => ({
        totaleFornitori: 0,
        fornitori: [],
        elencoFornitori: [],
        selected: [],
        loading: false,
        options: {},
        headers: [
          { text: 'Fornitore', value: 'codice', align: 'start'},
          { text: 'Descrizione', value: 'descrizione' },
          { text: 'Principale', value: 'default' },
          { text: 'Ultimo Movimento', value: 'movimento' },
          { text: 'Data u.m.', value: 'data' },
          { text: 'Prezzo u.m.', value: 'prezzo', align: 'end' },
          { text: 'Quantità u.m.', value: 'quantita', align: 'end' },
          { text: 'Actions', value: 'actions', sortable: false }
        ],
        filtri: null,
        causali: [],
        dialog: false,
        dialogDelete: false,
        editedIndex: -1,
        editedItem: {
          codice: '',
          ragioneSociale: '',
          default: false
        },
        defaultItem: {
          codice: '',
          ragioneSociale: '',
          default: false
        }
    }),
    watch: {
      async refresh() {
        await this.refreshFornitori()
      }
    },
    async mounted() {
      await this.refreshFornitori()  
    },
    computed: {
      fornitoriSorted() {
        const elSorted = _.sortBy(this.fornitori, ['data', 'descrizione'])
        return elSorted
      }   
    },
    methods: {
      onChangeDefault() {
        for (let f = 0; f < this.fornitori.length; f++) {
          if (f !== this.editedIndex) {
            this.fornitori[f].default = false
          }
        }
      },
      async refreshFornitori () {
        this.item.fornitori = this.item.fornitori || []
        if (!this.item.fornitori.some(x => x.default) && this.item.fornitori.length > 0) {
          // Se non c'è un fornitore principale ma sono stati caricati dei fornitori --> imposta il più recente come default
          let f = _.head(_.sortBy(this.item.fornitori, ['data', 'descrizione']))
          f.default = true
        }        
        this.fornitori = this.item.fornitori || []
        this.totaleFornitori = this.fornitori.length
        const fornitori = await clienti.getFornitori()
        this.elencoFornitori = _.sortBy(fornitori, ['descrizione'])
      },
      editItem (item) {
        this.editedIndex = this.fornitori.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = this.fornitori.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.fornitori.splice(this.editedIndex, 1)
        this.$emit('aggiorna', this.item)
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },      
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },      
      async save () {
        let fornitore = {
          codice: this.editedItem.codice,
          descrizione: this.editedItem.ragioneSociale,
          prezzo: null,
          quantita: null,
          data: null,
          movimento: null
        }
        if (this.editedIndex > -1) {
          Object.assign(this.fornitori[this.editedIndex], this.editedItem)
          this.$emit('aggiorna', this.item)
        } else {
          if (this.fornitori.length === 0) {
            fornitore.default = true
          }
          this.fornitori.push(fornitore)
          this.$emit('aggiorna', this.item)
        }
        this.close()
      }
    }
  }
</script>
